import * as fromPreorderPeriodActions from '../../actions/preorder/period.actions';
import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Action} from '@ngrx/store';
import {catchError, map, switchMap} from 'rxjs/operators';
import {of} from 'rxjs/internal/observable/of';
import {Observable} from 'rxjs';
import {PreorderRestService} from '../../../services/api/preorder.rest-service';

@Injectable()
export class PreorderPeriodEffects {
    private actions$ = inject(Actions);
    private preorderRestService = inject(PreorderRestService);

    loadVendorPeriodsByCategory$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType<fromPreorderPeriodActions.InitLoadVendorPeriodsByCategory>
            (fromPreorderPeriodActions.PeriodActionTypes.INIT_LOAD_VENDOR_PERIODS_BY_CATEGORY))
            .pipe(map(action => action.payload), switchMap((categoryUrl) =>
                    this.preorderRestService.loadVendorPeriodsByCategory(categoryUrl).pipe(
                        map(data => new fromPreorderPeriodActions.LoadVendorPeriodsByCategoryComplete(data.returnObject)),
                        catchError((error) => of(new fromPreorderPeriodActions.LoadVendorPeriodsByCategoryFailed(error)))
                    )
                )
            )
    );
}
